import { DbCheckReceipt } from "../../../data/usecases/check-receipt";
import { CheckReceipt } from "../../../domain/usecases/check-receipt";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl, makeAxiosHttpClient } from "../http";

export const makeDbCheckReceipt = (): CheckReceipt =>
  new DbCheckReceipt(
    makeApiUrl("/receipt/check"),
    makeAuthorizeHttpClientDecorator()
  );
